import React, { useRef, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from '@/components/Text';

const styles = StyleSheet.create({
  responsiveTextStyle: {
    overflow: 'hidden',
    textOverflow: 'clip',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    display: 'inline-block',
  },
});

function isTextTruncated(element) {
  return (
    element.offsetWidth < element.scrollWidth ||
    element.offsetHeight < element.scrollHeight
  );
}

const convertToPixels = (size) => `${size}px`;

const ResponsiveTextWeb = ({
  children,
  stylesTw,
  fontSize,
  minFontSize = 4,
  style,
  isResponsiveText,
}) => {
  const textContainerRef = useRef(null);

  const applyFontSize = (size) => {
    const container = textContainerRef.current;
    container.style.fontSize = convertToPixels(size);
    return isTextTruncated(container);
  };

  const adjustFontSize = () => {
    const container = textContainerRef.current;
    container.style.fontSize = null;
    const initialFontSize =
      fontSize || parseInt(getComputedStyle(container).fontSize, 10);

    let maxFontSize = initialFontSize;
    let minFontSizeLocal = minFontSize;
    let isTruncated = false;
    let optimalFontSize = minFontSizeLocal;
    let iterations = 0;
    const maxIterations = Math.log2(maxFontSize - minFontSizeLocal) + 1;

    while (maxFontSize > minFontSizeLocal && minFontSizeLocal < maxFontSize) {
      if (iterations > maxIterations) iterations++;

      const newFontSize = Math.floor((maxFontSize + minFontSizeLocal) / 2);
      isTruncated = applyFontSize(newFontSize);

      if (isTruncated) {
        maxFontSize = newFontSize - 1;
      } else {
        if (newFontSize > optimalFontSize) optimalFontSize = newFontSize;
        minFontSizeLocal = newFontSize + 1;
      }
    }

    applyFontSize(optimalFontSize * 0.98);
  };

  useEffect(() => {
    adjustFontSize();
  }, [children, fontSize]);

  return (
    <Text
      ref={textContainerRef}
      style={[styles.responsiveTextStyle, style]}
      stylesTw={stylesTw}
      isResponsiveText={true}
    >
      {children}
    </Text>
  );
};

export default ResponsiveTextWeb;
